import React from "react";
import { Link, useLocation } from "react-router-dom";
import "styles/panel.css";
import {
  adminMenuItems,
  teacherMenuItems,
  studentMenuItems,
} from "config/menuConfig";

const Sidebar = ({ user }) => {
  const location = useLocation();

  const getMenu = () => {
    if (user.role === "Teacher") return teacherMenuItems;
    if (user.role === "Student") return studentMenuItems;
    return adminMenuItems;
  };

  const menu = getMenu();

  return (
    <aside className="sidebar">
      <h2 className="logo">Algoritm Academy</h2>
      <nav className="menu">
        {menu.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`menu-item ${
              location.pathname.startsWith(item.path) ? "active" : ""
            }`}
          >
            {item.icon}
            {item.name}
          </Link>
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar;
